import React from 'react';

const ComposerContext = React.createContext();

export default ComposerContext;
